// variant: 'page' | 'panel' | 'inline'
export function ErrorState({
  heading = 'Something went wrong',
  body,
  onRetry,
  variant = 'panel',
}) {
  const sizes = {
    page:   'py-20 gap-4',
    panel:  'py-12 gap-3',
    inline: 'py-4  gap-2',
  };
  const headingSize = variant === 'page'
    ? 'text-lg font-semibold text-n-800'
    : 'text-sm font-medium text-n-700';

  return (
    <div className={`flex flex-col items-center text-center ${sizes[variant]}`}>
      <div className="w-10 h-10 rounded-full bg-status-bad-bg flex items-center justify-center text-status-bad shrink-0">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M9 6v4M9 12h.01" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
          <circle cx="9" cy="9" r="7.25" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </div>
      <p className={headingSize}>{heading}</p>
      {body && <p className="text-sm text-n-500 max-w-xs">{body}</p>}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 text-sm font-medium text-brand-black underline underline-offset-2 hover:no-underline"
        >
          Try again
        </button>
      )}
    </div>
  );
}
